// src/services/ai/AIProviderFactory.js
import GeminiProvider from './providers/GeminiProvider';
import ClaudeProvider from './providers/ClaudeProvider';
import CloudFunctionProvider from './providers/CloudFunctionProvider';

const providers = {
  gemini: GeminiProvider,
  claude: ClaudeProvider,
  'cloud-function': CloudFunctionProvider
};

/**
 * Create an AI provider instance
 * @param {string} type - Provider type: 'gemini', 'claude', or 'cloud-function'
 * @param {Object} config - Provider-specific configuration
 * @returns {AIProvider}
 */
export function createProvider(type = 'gemini', config = {}) {
  const ProviderClass = providers[type];
  if (!ProviderClass) {
    throw new Error(`Unknown AI provider: ${type}. Available: ${Object.keys(providers).join(', ')}`);
  }
  return new ProviderClass(config);
}
